module.exports = __webpack_public_path__ + "static/img/9.61937ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/9.png
// module id = If8y
// module chunks = 0